import React, { useState } from 'react'
import CarouselGallerySimple from '../CarouselGallerySimple'

const CarouselGallerySimpleApp = (props) => {
  const [zoom, setZoom] = useState(false)

  const handleImageClick = () => {
    if (!zoom) setZoom(true)
  }

  const handleClose = (e) => {
    e.preventDefault()
    setZoom(false)
  }

  return (
    <CarouselGallerySimple
      {...props}
      zoom={zoom}
      onImageClick={handleImageClick}
      onClose={handleClose}
    /> 
  )
}

export default CarouselGallerySimpleApp
